import React, { useRef } from 'react';
import Title from '../../components/shared/Title';
import DataGrid, {
    Column,
    ColumnChooser,
    Editing,
    Export,
    FilterRow,
    HeaderFilter,
    Lookup,
    Pager,
    Paging,
    Button as ButtonGrid 
  } from 'devextreme-react/data-grid';
import { createStoreLocal } from '../../utils/proxy';
import uri from '../../utils/uri';
import { store } from '../../services/store';
import CustomButton from '../../components/buttons/CustomButton';
import { useDispatch } from 'react-redux'
import { dialogProduct } from '../../store/product/productDialogReducer';
import BlockHeader from '../../components/shared/BlockHeader';
import Nuevo from './Nuevo';
import useAuthorization from '../../hooks/useAuthorization';
import { resources } from '../../data/app';
import { dataFormatId } from '../../utils/common';
import { defaultLabels } from '../../data/defaultObjects';


const Products = (props) => {

    const [ authorized ] = useAuthorization( resources.inventario );

    let dataGrid = useRef();
    const dispatch = useDispatch();

    const reload = (params) => {
        dataGrid.current.instance.refresh();
    }

    const openDialog = (id=0) => dispatch(dialogProduct({open : true, id}));

    const onToolbarPreparing = (e) => {
        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Exportar a excel',
                icon: 'exportxlsx',
                type: 'success',
                stylingMode: "outlined",
                onClick: () => dataGrid.current.instance.exportToExcel(false)
            }
        });
    }

    const title = "Inventario";

    return authorized(
        <div className="container">
            <Title title={title}/>
            <BlockHeader showFavorite={true} title={title} {...props}>
                <CustomButton
                    text="Crear inventario"
                    icon='plus'
                    onClick={() => openDialog(0)}
                />
            </BlockHeader>
            <Nuevo onSave={reload}/>
            <DataGrid id="gridContainer"
                ref={dataGrid}
                selection={{ mode: 'single' }}
                dataSource={store({ uri : uri.products, remoteOperations : true })}
                showBorders={true}
                showRowLines={true}
                allowColumnResizing={true}
                allowColumnReordering={true}
                onToolbarPreparing={onToolbarPreparing}
                remoteOperations={{
                    paging: true,
                    filtering: true
                }}     
            >
                <Paging defaultPageSize={20} />
                <Pager
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50]}
                    showInfo={true} 
                />
                <FilterRow visible={true} />
                <HeaderFilter visible={true} />
                <ColumnChooser enabled={true} />
                <Export enabled={false} fileName={title} allowExportSelectedData={true} />
                <Column dataField="id" caption='Codigo' width={80} cellRender={dataFormatId} visible={false}/>
                <Column dataField="internalCode" caption='Codigo' width={90}/>
                <Column dataField="name" caption='Nombre' minWidth={120}/>               
                <Column dataField="description" caption='Descripcion' visible={false} />
                
                <Column dataField="presentationId" caption={defaultLabels.presentacion} width={180}>
                    <Lookup disabled={true} dataSource={createStoreLocal({name:'presentation'})} valueExpr="id" displayExpr="name" />
                </Column> 
                <Column dataField="familyId" caption={defaultLabels.family} width={180}>
                    <Lookup disabled={true} dataSource={createStoreLocal({name:'family'})} valueExpr="id" displayExpr="name" />
                </Column> 
                <Column dataField="unitOfMeasureId" caption="UM" width={120}>
                    <Lookup disabled={true} dataSource={createStoreLocal({name: 'unitOfMeasure'})} valueExpr="id" displayExpr="name" />
                </Column>
                <Column dataField="ubication" caption='Ubicacion' visible={true} width={180}/>
                <Column dataField="stateId" caption="Estado" width={100}>
                    <Lookup disabled={true} dataSource={createStoreLocal({name: 'productState'})} valueExpr="id" displayExpr="name" />
                </Column>               
                <Column dataField="hasIva" caption='IVA ?' type="boolean" width={80} dataType="boolean" visible={false}/>
                <Column dataField="stock" caption='Stock' width={90} visible={false}/>
                <Column dataField="createBy" caption='Creado Por' visible={false}/>
                <Column dataField="createAt" caption='Creado el' visible={false} />
                <Column dataField="lastModificationBy" caption='Modificado Por' visible={false}/>
                <Column dataField="lastDateModificationAt" caption='Modificado el' visible={false} />
                <Column type="buttons" width={60}>
                    <ButtonGrid name="edit" onClick={e => openDialog(e.row.data.id)}/>
                    <ButtonGrid name="delete" />
                </Column>
                <Editing
                    mode="popup"
                    useIcons={true}
                    allowUpdating={true}
                    allowDeleting={true}
                >
                </Editing>
            </DataGrid>
        </div>
    );
}

export default Products;
